import { useEffect, useState } from 'react';
import axios from 'axios';
import { promptUpgrade } from '@/components/billing/PlanUpgradeModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TEAM_ROLES = ['admin', 'staff', 'project_manager', 'designer', 'site_engineer'];
export const EXPORT_LOCK_MESSAGE = 'Export is available from the Essential plan onwards. Upgrade to unlock PDF and Excel exports.';
let _cache = null;
let _cacheToken = null;

// Plan gate for PDF / Excel exports. Owner + portal roles (client/vendor) are never gated.
export function useExportGate() {
  const token = localStorage.getItem('token');
  const [perms, setPerms] = useState(_cacheToken === token ? _cache : null);
  useEffect(() => {
    if (_cache && _cacheToken === token) return;
    axios.get(`${API}/plan/permissions`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => { _cache = r.data?.permissions || {}; _cacheToken = token; setPerms(_cache); })
      .catch(() => {});
  }, [token]);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const gated = TEAM_ROLES.includes(user.role);
  const locked = gated && !!perms && !(perms.can_export_pdf || perms.can_export_excel);
  const guard = (fn) => (...args) => {
    if (locked) {
      promptUpgrade('can_export_pdf', 'essential', EXPORT_LOCK_MESSAGE);
      return undefined;
    }
    return fn(...args);
  };
  return { exportLocked: locked, guardExport: guard };
}
